import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSplunkLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 40 40",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.76172 4.7619C6.55258 4.7619 4.76172 6.55276 4.76172 8.7619V31.2381C4.76172 33.4472 6.55258 35.2381 8.76172 35.2381H31.2379C33.447 35.2381 35.2379 33.4472 35.2379 31.2381V8.7619C35.2379 6.55276 33.447 4.7619 31.2379 4.7619H8.76172ZM28.9998 22.6986V19.3562L12.9998 11.1538V14.8326L25.3993 21L12.9998 27.2512V30.8462L28.9998 22.6986Z",
		fill: "#64A525"
	})]
});
const ForwardRef = forwardRef(SvgSplunkLogo);
export { ForwardRef as ReactComponent };
